export const ONBOARDING_DEMO_MAILBOX_CREATED =
  'onboarding/addChannelPage/DEMO_MAILBOX_CREATED'
